import { ws } from "../../../utils/common";
import moment from "moment/moment";

export const getDailyProgramWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "calendar/daily/",
    { date: moment().format("YYYY-MM-DD") },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getFavourtieAssociationsWS = async ({ favourite = true }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/",
    { favourite },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getAssociationWhereIAmVolunteerWS = async ({ limit = 8 }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/",
    { volunteer: true, limit },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getFeedEventsWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/",
    { favourite: true },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
